export default __webpack_public_path__ + "static/media/r.280072c3.png";